import { LOCIZE_NS, MUTATION_KEYS, QUERY_KEYS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import {
  useDeletePatient,
  type DeletePatientVariables,
} from '@avanta/shared/hooks/useDeletePatient';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

export const useDeleteInsuredPerson = (): UseMutationResult<
  void,
  Error,
  DeletePatientVariables
> => {
  const queryClient = useQueryClient();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.PROFILE);
  const { mutateAsync: deletePatient } = useDeletePatient();

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_PATIENT, 'insured'],
    mutationFn: (variables: DeletePatientVariables) => deletePatient(variables),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_INSURED_USERS] });
      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_INSURED_USERS_COUNT] });
      void queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.FETCH_ENTERPRISE_APPOINTMENTS],
      });
      hideDialog();
      toast.success(t('DeleteAccount.success'));
    },
    onError: () => {
      toast.error(t('DeleteAccount.error'));
    },
  });
};
